import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components/src/styles';

export const tabPanelContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  min-height: 48px;

  > button {
    min-width: 160px;
    white-space: nowrap;
  }
`;

export const headingWrapper = css`
  display: flex;
  flex-direction: column;
  margin: 30px 20px 10px 20px;
`;

export const headingAndLearnMoreButton = css`
  display: flex;
  align-items: center;

  > :last-child {
    margin-left: 40px;
    height: 100%;
  }
`;

export const listInfo = css`
  display: flex;
  flex-direction: column;
  margin: 20px;
`;

export const bodyText = css`
  margin-top: 20px;
`;

export const divider = css`
  margin-top: 10px;
`;

export const emptyStateTitle = css`
  padding-left: 20px;
`;

export const learnMoreButton = css`
  display: flex;
  align-items: center;
  color: ${colors.primary.default};
  font-weight: ${fonts.weight.bold};

  :visited {
    color: ${colors.primary.default};
  }

  :hover {
    color: ${colors.primary.hover};
  }
`;

export const learnMoreIcon = css`
  height: ${icons.size.small};
  width: ${icons.size.small};
  margin-right: 10px;
`;
